import React from 'react'
import { twMerge } from 'tailwind-merge'

import { columns } from '@ui-kit/components/layoutComponents/Columns/styles'

import type { WebProps } from './types'

const Columns = (props: WebProps) => {
  const { collapseOnMobile, collapsedSpace, space, ...divProps } = props
  const className = columns({
    collapseOnMobile,
    collapsedSpace: collapsedSpace ?? space,
    space,
  })
  return (
    <div {...divProps} className={twMerge(className, props.className)}>
      {props.children}
    </div>
  )
}

export default Columns
